(() => {
  'use strict';
  if (window.__carvionEvaDetails) return;
  window.__carvionEvaDetails = true;

  const HOVER_SCALE = 2.2;
  const SWIPE_MIN = 48;
  const selectedMatType = () => {
    const checked = document.querySelector('.product-form__input[data-name="mats_type"] input:checked');
    return checked?.dataset.name === '3d' ? '3d' : 'classic';
  };
  const canHoverZoom = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const narrow = () => matchMedia('(max-width: 749px)').matches;

  function init() {
    document.querySelectorAll('[data-eva-details]').forEach(dialog => {
      if (dialog.dataset.evaReady) return;
      dialog.dataset.evaReady = 'true';

      const stage = dialog.querySelector('[data-eva-stage]');
      const zoom = dialog.querySelector('[data-eva-zoom]');
      const zoomLabel = zoom.querySelector('[data-eva-zoom-label]');
      const title = dialog.querySelector('[data-eva-title]');
      const lead = dialog.querySelector('[data-eva-lead]');
      const photos = [...stage.querySelectorAll('[data-eva-photo]')];
      const switches = [...dialog.querySelectorAll('[data-eva-type-switch] [data-eva-type]')];
      let type = 'classic';
      let current = null;
      let panX = 0;
      let panY = 0;
      let drag = null;
      let swipe = null;
      let hover = {x: 50, y: 50, scale: 1};

      const activePhoto = () => photos.find(frame => frame.dataset.evaPhoto === type)?.querySelector('img');
      const activePins = () => stage.querySelector(`[data-eva-pins="${type}"]`);
      const activeGroup = () => dialog.querySelector(`[data-eva-group="${type}"]`);
      const options = () => [...(activeGroup()?.querySelectorAll('.carvion-eva-option') || [])];
      const setImageState = state => {
        stage.dataset.state = state;
        stage.querySelector('[data-eva-loading]').hidden = state !== 'loading';
        stage.querySelector('[data-eva-error]').hidden = state !== 'error';
        zoom.disabled = state !== 'success';
      };
      const updateImageState = () => {
        const photo = activePhoto();
        if (!photo) return setImageState('error');
        if (!photo.complete) return setImageState('loading');
        setImageState(photo.naturalWidth ? 'success' : 'error');
      };
      // A zoomed photo needs more pixels than the small layout slot asks the browser for.
      const requestSharpPhoto = () => {
        const photo = activePhoto();
        if (!photo || photo.dataset.evaSharp) return;
        photo.dataset.evaSharp = 'true';
        photo.sizes = '(min-width: 750px) 1400px, 200vw';
      };
      // Pins live outside the scaled photo so they keep their size. Their position is projected
      // through the same zoom (x' = origin + (x - origin) * scale); pins pushed off the photo hide.
      const projectPins = () => {
        stage.style.setProperty('--zx', hover.x);
        stage.style.setProperty('--zy', hover.y);
        stage.style.setProperty('--zs', hover.scale);
        activePins()?.querySelectorAll('.carvion-eva-pin').forEach(pin => {
          const x = hover.x + (parseFloat(pin.style.getPropertyValue('--px')) - hover.x) * hover.scale;
          const y = hover.y + (parseFloat(pin.style.getPropertyValue('--py')) - hover.y) * hover.scale;
          pin.toggleAttribute('data-off', x < 4 || x > 96 || y < 3 || y > 97);
        });
      };
      const setHoverZoom = (active, x = hover.x, y = hover.y) => {
        hover = {x, y, scale: active ? HOVER_SCALE : 1};
        stage.dataset.hoverZoom = String(active);
        projectPins();
      };
      const resetZoom = () => {
        drag = null;
        swipe = null;
        panX = 0;
        panY = 0;
        stage.style.setProperty('--eva-pan-x', '0px');
        stage.style.setProperty('--eva-pan-y', '0px');
        stage.dataset.dragging = 'false';
        stage.dataset.zoomed = 'false';
        zoom.setAttribute('aria-pressed', 'false');
        zoomLabel.textContent = zoom.dataset.zoomIn;
        setHoverZoom(false, 50, 50);
      };
      // One point is always open: its pin is pressed and its list item shows the text.
      const showFeature = (key, focusOn) => {
        current = key;
        activePins()?.querySelectorAll('.carvion-eva-pin').forEach(pin => pin.setAttribute('aria-pressed', String(pin.dataset.evaFeature === key)));
        options().forEach(option => {
          const open = option.dataset.evaFeature === key;
          option.setAttribute('aria-expanded', String(open));
          option.closest('.carvion-eva-item')?.classList.toggle('is-open', open);
        });
        if (focusOn === 'pin') activePins()?.querySelector(`[data-eva-feature="${key}"]`)?.focus();
        if (focusOn === 'option') activeGroup()?.querySelector(`.carvion-eva-option[data-eva-feature="${key}"]`)?.focus();
      };
      const stepFeature = (direction, focusOn) => {
        const keys = options().map(option => option.dataset.evaFeature);
        if (!keys.length) return;
        const at = Math.max(0, keys.indexOf(current));
        showFeature(keys[(at + direction + keys.length) % keys.length], focusOn);
      };
      // The dialog's own switch only changes what the dialog shows; the configurator keeps its choice.
      const setType = next => {
        type = next === '3d' ? '3d' : 'classic';
        stage.dataset.matType = type;
        resetZoom();
        photos.forEach(frame => { frame.hidden = frame.dataset.evaPhoto !== type; });
        stage.querySelectorAll('[data-eva-pins]').forEach(pins => { pins.hidden = pins.dataset.evaPins !== type; });
        dialog.querySelectorAll('[data-eva-group]').forEach(group => { group.hidden = group.dataset.evaGroup !== type; });
        switches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.evaType === type)));
        const first = options()[0]?.dataset.evaFeature;
        if (first) showFeature(first);
        title.textContent = title.getAttribute(`data-${type}-copy`);
        lead.textContent = lead.getAttribute(`data-${type}-copy`);
        updateImageState();
      };
      const syncType = () => setType(selectedMatType());

      photos.forEach(frame => {
        const photo = frame.querySelector('img');
        if (!photo) return;
        photo.draggable = false;
        photo.addEventListener('load', () => { if (photo === activePhoto()) setImageState('success'); });
        photo.addEventListener('error', () => { if (photo === activePhoto()) setImageState('error'); });
      });

      dialog.addEventListener('click', event => {
        const typeButton = event.target.closest('[data-eva-type]');
        if (typeButton && dialog.contains(typeButton)) {
          if (typeButton.dataset.evaType !== type) setType(typeButton.dataset.evaType);
          return;
        }
        const feature = event.target.closest('[data-eva-feature]');
        if (feature && dialog.contains(feature)) {
          showFeature(feature.dataset.evaFeature);
          // On phones the list sits below the photo: bring the opened text into view after a pin tap.
          if (feature.classList.contains('carvion-eva-pin') && narrow()) {
            activeGroup()?.querySelector('.carvion-eva-item.is-open')?.scrollIntoView({block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth'});
          }
          return;
        }
        if (event.target.closest('[data-eva-zoom]') && !zoom.disabled) {
          if (zoom.getAttribute('aria-pressed') === 'true') resetZoom();
          else {
            setHoverZoom(false, 50, 50);
            requestSharpPhoto();
            stage.dataset.zoomed = 'true';
            zoom.setAttribute('aria-pressed', 'true');
            zoomLabel.textContent = zoom.dataset.zoomOut;
          }
        }
      });
      // Arrow keys walk the three points from a pin or from a list item; focus follows.
      dialog.addEventListener('keydown', event => {
        const steps = {ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1};
        if (!(event.key in steps)) return;
        const origin = event.target.closest('.carvion-eva-option, .carvion-eva-pin');
        if (!origin || !dialog.contains(origin)) return;
        event.preventDefault();
        stepFeature(steps[event.key], origin.classList.contains('carvion-eva-pin') ? 'pin' : 'option');
      });

      stage.addEventListener('pointerdown', event => {
        if (event.target.closest('.carvion-eva-pin')) return;
        if (stage.dataset.zoomed === 'true') {
          event.preventDefault();
          stage.setPointerCapture(event.pointerId);
          drag = {id: event.pointerId, x: event.clientX, y: event.clientY, panX, panY};
          stage.dataset.dragging = 'true';
          return;
        }
        // Touch: a horizontal swipe across the photo moves to the next / previous point.
        if (event.pointerType !== 'mouse') swipe = {id: event.pointerId, x: event.clientX, y: event.clientY};
      });
      stage.addEventListener('pointermove', event => {
        if (drag && drag.id === event.pointerId) {
          const maxX = stage.clientWidth * 0.23;
          const maxY = stage.clientHeight * 0.23;
          panX = Math.max(-maxX, Math.min(maxX, drag.panX + event.clientX - drag.x));
          panY = Math.max(-maxY, Math.min(maxY, drag.panY + event.clientY - drag.y));
          stage.style.setProperty('--eva-pan-x', `${panX}px`);
          stage.style.setProperty('--eva-pan-y', `${panY}px`);
          return;
        }
        // Desktop magnifier: the photo scales around the cursor. Over a pin the origin is frozen,
        // so the number stays still under the pointer and can be clicked.
        if (event.pointerType !== 'mouse' || !canHoverZoom() || stage.dataset.zoomed === 'true' || stage.dataset.state !== 'success') return;
        if (event.target.closest('.carvion-eva-pin')) return;
        const box = stage.getBoundingClientRect();
        const x = Math.max(0, Math.min(100, (event.clientX - box.left) / box.width * 100));
        const y = Math.max(0, Math.min(100, (event.clientY - box.top) / box.height * 100));
        requestSharpPhoto();
        setHoverZoom(true, x, y);
      });
      stage.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && stage.dataset.zoomed !== 'true') setHoverZoom(false);
      });
      const endPointer = event => {
        if (drag && drag.id === event.pointerId) {
          drag = null;
          stage.dataset.dragging = 'false';
        }
        if (swipe && swipe.id === event.pointerId) {
          const dx = event.clientX - swipe.x;
          const dy = event.clientY - swipe.y;
          swipe = null;
          if (event.type === 'pointerup' && Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy) * 1.4) stepFeature(dx < 0 ? 1 : -1);
        }
      };
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);

      dialog.addEventListener('close', resetZoom);
      document.addEventListener('change', event => {
        if (event.target.matches('.product-form__input[data-name="mats_type"] input')) syncType();
      });
      document.addEventListener('evamats:config-step-updated', syncType);
      dialog.addEventListener('toggle', () => { if (dialog.open) syncType(); });
      syncType();
    });
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
